import React from "react";
import {
  FaAward,
  FaTruck,
  FaBoxes,
  FaHandshake,
  FaHeadset,
  FaPalette,
} from "react-icons/fa";
import useScrollReveal from "../hooks/useScrollReveal";
import "./WhyChoose.css";

const reasons = [
  {
    icon: <FaAward />,
    title: "Premium Quality",
    text: "We focus on reliable products, quality materials, and professional finishing.",
  },
  {
    icon: <FaTruck />,
    title: "UAE Wide Delivery",
    text: "Fast and dependable delivery support for businesses across the UAE.",
  },
  {
    icon: <FaBoxes />,
    title: "Wide Product Range",
    text: "Office supplies, stationery, school products, signage, printing, and branding solutions.",
  },
  {
    icon: <FaPalette />,
    title: "Custom Branding",
    text: "Creative solutions for signage, corporate gifts, packaging, and promotional items.",
  },
  {
    icon: <FaHandshake />,
    title: "Trusted Partner",
    text: "Supporting companies with professional service and long-term business relationships.",
  },
  {
    icon: <FaHeadset />,
    title: "Quick Support",
    text: "Easy communication through WhatsApp, call, email, and enquiry forms.",
  },
];

const WhyChoose = () => {
  const [gridRef, gridVisible] = useScrollReveal();

  return (
    <section className="why-section">
      <div className="why-header">
        <span>Why Choose Us</span>
        <h2>Why Businesses Choose SG Office</h2>
        <p>
          We provide reliable office supply and branding solutions designed for
          modern business needs.
        </p>
      </div>

      <div className="why-grid" ref={gridRef}>
        {reasons.map((item, index) => (
          <div
            className={`why-card ${gridVisible ? "why-card-visible" : ""}`}
            key={index}
            style={{ transitionDelay: gridVisible ? `${index * 0.09}s` : "0s" }}
          >
            <div className="why-icon">{item.icon}</div>
            <h3>{item.title}</h3>
            <p>{item.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyChoose;